<div class="shift-compliance-container">
	<div class="shift-compliance-bottom">
		<h2 class="ready-set-header">Support Beyond the Screen</h2>
		<p class="mt-4 ready-set-content mb-5">
			When you buy RegScale, you are getting more than just software, you
			are getting software with a service. Our partner ecosystem provides
			professional services, integrations, and best practices that can
			further enhance the business value of our platform. Some of our
			premier partners are shown below
		</p>

		<h2 class="trusted-header mb-4 mb-lg-5">Featured Partners</h2>
		<div class="row">
			<div class="col-md-4">
				<a href="https://www.riskcypher.com/" target="_blank">
					<img src="../../assets/img/RiskCypher-Black.png" alt="Risk Cypher" style="max-height: 150px;" />
				</a>
			</div>

			<div class="col-md-4">
				<a href="https://www.carahsoft.com/regscale" target="_blank">
					<img src="../../assets/img/Carasoft-Black.png" alt="Carahsoft" style="max-height: 150px;" />
				</a>
			</div>

			<div class="col-md-4">
				<a href="https://www.calibresys.com/" target="_blank">
					<img src="../../assets/img/Calibre-Black.png" alt="Calibre" style="max-height: 150px;" />
				</a>
			</div>
		</div>
		<div class="row mt-2">
			<div class="col-md-4">

			</div>
			<div class="col-md-4">
				<a href="https://www.eit2.com/resources/articles/future-of-FedRAMP" target="_blank">
					<img src="../../assets/img/eit.png" alt="E-Magine IT" style="max-height: 150px; margin-top: 50px;" />
				</a>
			</div>
			<div class="col-md-4">

			</div>
		</div>

	</div>
</div>
